import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

// Keep libraries array stable across renders to avoid LoadScript reload warnings
const GMAPS_LIBRARIES = ['marker'] as const;

/**
 * Jedyne miejsce z opcjami ladowania Google Maps. Loader z @googlemaps/js-api-loader jest jeden
 * na strone i rzuca wyjatek W TRAKCIE RENDERU, gdy ktos wywola go z innymi opcjami - tak bylo,
 * gdy tabela zamowien tworzyla go przy starcie z pustym kluczem, a karta Mapa chwile pozniej
 * z kluczem z backendu: wyjatek wywracal cala strone glowna. Dlatego wolac tylko ze znanym,
 * niepustym kluczem (komponent z mapa renderowac dopiero, gdy klucz jest).
 */
export function useMapyGoogle(apiKey: string) {
  return useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: apiKey,
    version: 'weekly',
    libraries: GMAPS_LIBRARIES as any
  });
}

/** Wariant dla JSX: dzieci dostaja stan ladowania biblioteki. */
const LadowanieMapGoogle: React.FC<{
  apiKey: string;
  children: (stan: { isLoaded: boolean; loadError: Error | undefined }) => React.ReactNode;
}> = ({ apiKey, children }) => {
  const { isLoaded, loadError } = useMapyGoogle(apiKey);
  return <>{children({ isLoaded, loadError })}</>;
};

export default LadowanieMapGoogle;
